import { render, staticRenderFns } from "./EditProspect.vue?vue&type=template&id=a550a04e&"
import script from "./EditProspect.vue?vue&type=script&lang=js&"
export * from "./EditProspect.vue?vue&type=script&lang=js&"
import style0 from "./EditProspect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports